/**
 * @module windowOpener
 * @description Open link in new window popup, instead of new tab (in which the time of edit)
 *
 * @example
 * WindowOpener.open('https://ixdf.org');
 *
 * @example
 * const onLinkClosed = () => {
 *  // window closed listener
 * }
 * WindowOpener.openAndCallOnClosing('https://ixdf.org', onLinkClosed);
 */
const DEFAULT_WINDOW_OPTIONS = 'width=600,height=400,toolbar=0,menubar=0,location=0,resizable=1,scrollbars=1,status=0';

/**
 * Open popup window
 * @param {string} url
 * @returns {Window}
 */
export function openAsWindow(url) {
    return window.open(url, `ixdf-window-${Date.now()}`, DEFAULT_WINDOW_OPTIONS);
}
